/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { useLocation } from "react-router-dom"
import { Theme } from "../types"
import { SelectorListItem } from "../UI/List/Selector/selectorTypes"
import { CartOrder, CartOrderDetails } from "./cartTypes"
import CartOrderList from "./List"

function CartConfirm() {
    const location = useLocation<{
        order: CartOrder<CartOrderDetails>
        selectedBuyer: SelectorListItem | null
    }>()

    return (
        <div css={styles.root}>
            {location.state.selectedBuyer !== null && (
                <h3>{location.state.selectedBuyer?.label}</h3>
            )}
            <CartOrderList order={location.state.order} />
            <div css={styles.messageContainer}>
                <h1>Sikeresen elküldve!</h1>
            </div>
        </div>
    )
}

export default CartConfirm

const styles = {
    root: css`
        display: flex;
        flex-direction: column;
    `,
    messageContainer: (theme: Theme) => css`
        display: flex;
        justify-content: center;
        border: solid 2px ${theme.palette.success.main};
        border-radius: ${theme.spaces.smallScale.xxl};
        color: ${theme.palette.success.dark};
    `,
}
